<template>
  <div ref="container">
    <a-modal :title="title" width="98%" :visible="visible" :confirmLoading="confirmLoading"
             :getContainer="() => $refs.container" :maskStyle="{'top':'23px','left':'154px'}"
             :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false"
             @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:3%;height: 90%;">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          关闭
        </a-button>
        <a-button type="primary" @click="handleOk">
          确认
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <div class="productInfo">
          <!--          <span class="title">商品基本信息</span>-->
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row">
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="公司名称" prop="companyName">
                  <a-input placeholder="请输入公司名称" v-model="form.companyName" />
                </a-form-model-item>
              </a-col>
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="统一社会信用代码"
                                   prop="unifiedSocialCreditCode">
                  <a-input placeholder="统一社会信用代码" v-model="form.unifiedSocialCreditCode" />
                </a-form-model-item>
              </a-col>
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="公司行政区" prop="companyAddressAreaId">
                  <div>
                    <a-select placeholder="省" style="width: 30%;margin-right: 4%" v-model="address.value1"
                              @change="(val)=>{getAddressList(val,'list2',['value2','value3'])}">
                      <a-select-option :value="item.regionCode" v-for="(item,index) in address.list1">{{item.regionName}}</a-select-option>
                    </a-select>
                    <a-select placeholder="市" style="width: 30%;margin-right: 4%" v-model="address.value2"
                              @change="(val)=>{getAddressList(val,'list3','value3')}">
                      <a-select-option :value="item.regionCode" v-for="(item,index) in address.list2">{{item.regionName}}</a-select-option>
                    </a-select>
                    <a-select placeholder="区/县" style="width: 31%"  v-model="form.companyAddressAreaId">
                      <a-select-option :value="item.keyId" v-for="(item,index) in address.list3">{{item.regionName}}</a-select-option>
                    </a-select>
                  </div>
                </a-form-model-item>
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="详细地址" prop="companyAddressDetail">
                  <a-input placeholder="请输入详细地址" v-model="form.companyAddressDetail" />
                </a-form-model-item>

              </a-col>
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件" prop="attachment">
                  <j-image-upload v-model="form.attachment" bizPath="material" text="上传" isMultiple></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人" prop="contactName">
                  <a-input placeholder="请输入联系人" v-model="form.contactName" @change="c"/>
                </a-form-model-item>
              </a-col>
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话" prop="contactPhone">
                  <a-input placeholder="请输入联系电话" v-model="form.contactPhone" @change="c"/>
                </a-form-model-item>
              </a-col>

              <template v-for="(item,index) in chengYunRenList" >
                <a-col :span="11">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="'承运人'+(index+1)" prop="carrierName">
                    <a-input placeholder="请输入承运人" v-model="item.carrierName" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="11">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话" prop="carrierPhone">
                    <a-input placeholder="请输入联系电话" v-model="item.carrierPhone" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="2">
                  <a-form-model-item>
                    <a-button v-if='index != 0' type="danger" @click="chengYunRenDel(index)" style="margin-right: 10px">删除</a-button>
                    <a-button v-if="(index+1) == chengYunRenList.length" type="primary" @click="chengYunRenAdd">新增</a-button>
                  </a-form-model-item>
                </a-col>
              </template>

              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结算方式" prop="settlementMethod" placeholder="请选择结算方式">
                  <a-select v-model="form.settlementMethod">
                    <a-select-option value="0">月结</a-select-option>
                    <a-select-option value="1">寄付现结</a-select-option>
                    <a-select-option value="2">到付</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="11">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="reason">
                  <a-textarea v-model="form.remark" placeholder="备注"></a-textarea>
                </a-form-model-item>
              </a-col>
            </a-row>

          </a-form-model>
        </div>

      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import JImageUpload from '@/components/jeecg/JImageUpload'
import {
  addressget,
  addresslist,
  carrierMangaementadd, carrierMangaementedit, carrierMangaementqueryById,
  checkSupplier,
  ledgerAdd,
  ledgerEdit,
  supplyAdd,
  supplyEdit
} from '@/api/api'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import JAreaLinkage from '@comp/jeecg/JAreaLinkage.vue'


export default {
  name: 'VendorModal',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JAreaLinkage,
    JImageUpload
  },
  // props:['productType'],
  props: {
    productType: Number
  },
  data () {
    return {
      address:{
        list1:[],
        value1:'',
        list2:[],
        value2:'',
        list3:[],
        value3:''
      },
      List:[],
      headers: {
        'X-Access-Token': Vue.ls.get(ACCESS_TOKEN),
        tenantId: this.$store.getters.tenantId,
        createBy: this.$store.getters.userInfo.loginName,
      },
      title: '操作',
      visible: false,
      fileList: [],
      model: {},
      companyId: '',
      isReadOnly: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span:7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      chengYunRenList:[
        {
          carrierName:'',
          carrierPhone:'',
          isDefault:1
        }
      ],
      form: {
        companyAddressAreaId:''
      },
      uploadHeaders: {},
      action: window._CONFIG['domianURL'] + '/systemConfig/upload',
      rules: {
        companyName: [{ required: true, message: '请输入公司名称' }],
        unifiedSocialCreditCode: [{ required: true, message: '请输入统一社会信用代码' }],
        // attachment: [{ required: true, message: '请上传附件' }],
        companyAddressAreaId:[{ required: true,validator:(_,value)=>{
            if(!this.form.companyAddressAreaId ){
              return Promise.reject('请输入承运人')
            }
            return Promise.resolve()
          }}],
        companyAddressDetail: [{ required: true, message: '请输入公司地址详细地址' }],
        contactName: [{ required: true, message: '请输入联系人' }],
        contactPhone: [{ required: true, message: '请输入联系电话' }],
        settlementMethod: [{ required: true, message: '请选择结算方式' }],
        carrierName:[{ required: true,validator:(_,value)=>{
            if(!this.chengYunRenList[0].carrierName ){
              return Promise.reject('请输入承运人')
            }
            return Promise.resolve()
          }}],
        carrierPhone:[{ required: true,validator:(_,value)=>{
            if(!this.chengYunRenList[0].carrierPhone ){
              return Promise.reject('请输入承运人联系电话')
            }
            return Promise.resolve()
          }}],
      },
      id: ''
    }
  },
  created () {
  },
  methods: {
    c(){
      this.chengYunRenList[0].carrierName = this.form.contactName
      this.chengYunRenList[0].carrierPhone = this.form.contactPhone
    },
    getAddressList(code,name,value){
      addresslist({
        parentCode: code,
      }).then(res=>{
        console.log(res.result)
        this.address[name] = res.result
        if(value){
          if(Array.isArray(value)){
            value.forEach(v=>{
              this.address[v] = ''
              if(v == 'value3'){
                this.form.companyAddressAreaId = ''
              }
            })
          }else{
            this.address[value] = ''
            if(value == 'value3'){
              this.form.companyAddressAreaId = ''
            }
          }
        }
      })
    },

    chengYunRenDel(index){
      if(this.chengYunRenList.length > 1){
        this.chengYunRenList.splice(index,1)
      }else{
        this.$message.warning('必须保留一个承运人')
      }
    },
    chengYunRenAdd(){
      this.chengYunRenList.push({
        carrierName:'',
        carrierPhone:'',
        isDefault:0
      })
    },
    beforeUpload () {
      console.log('上传前')
      console.log(this.List, 'List')
      if (this.List.length > 0 && this.List[0].status == 'removed') {
        return true
      }
      if (this.List.length > 0) {
        // console.log('只能上传一个')
        this.$message.error('只能上传一个,请先删除暂存文件')
        return false
      }
    },
    add () {
      this.form = {companyAddressAreaId:''}
      this.address = {
        list1:[],
        value1:'',
        list2:[],
        value2:'',
        list3:[],
        value3:''
      }
      this.chengYunRenList=[
        {
          carrierName:'',
          carrierPhone:'',
          isDefault:1
        }
      ]
      this.getAddressList('100000','list1',)
      this.visible = true
    },
    edit (record) {
      const that = this
      that.getAddressList('100000','list1',)

      carrierMangaementqueryById({id:record.id}).then(res=>{
        record = res.result
        that.form = record
        that.chengYunRenList = record.carrierUsers
        addressget({id:record.companyAddressAreaId}).then(res=>{
          that.address.value1 = res.result.provincialCode
          that.getAddressList(res.result.provincialCode,'list2')
          that.address.value2 = res.result.municipalCode
          that.getAddressList(res.result.municipalCode,'list3')
          that.address.value3 = res.result.districtCode
        })

        this.visible = true
        this.$nextTick(() => {
        })
      })

    },
    handleChange (e) {
      if (e.file.response.code == 500) return this.$message.error(e.file.response.msg)
      console.log(e, 'e')
      this.List = e.fileList
      if (e.fileList.length == '1' && e.fileList[0].status == 'done') {
        this.uploadfile(e)
      }
    },
    close () {
      this.$emit('close')
      this.visible = false
    },
    handleOk () {
      const that = this
      // 触发表单验证
      that.$refs['form'].validate(async (success) => {
        if (success === true) {
          this.form.carrierUsers = this.chengYunRenList
          if (this.form.id) {
            // 编辑
            const res = await carrierMangaementedit(this.form)
            console.log(res, 'res')
            if (res.code == 200 && res.success == true) {
              this.$message.success(res.message)
              this.$emit('ok')
              this.close()
            } else {
              this.$message.error(res.data || res.errmsg)
            }
          } else {
            const res = await carrierMangaementadd(this.form)
            if (res.code == 200 && res.success == true) {
              this.$message.success(res.message)
              this.$emit('ok')
              this.close()
            } else {
              this.$message.error(res.message)
            }
          }
        }
      })
    },
    handleCancel () {
      this.close()
    },
    validateSupplierName (rule, value, callback) {
      let params = {
        name: value,
        type: '供应商',
        id: this.model.id ? this.model.id : 0
      }
      checkSupplier(params).then((res) => {
        if (res && res.code === 200) {
          if (!res.data.status) {
            callback()
          } else {
            callback('名称已经存在')
          }
        } else {
          callback(res.data)
        }
      })
    }
  }
}
</script>
<style scoped>
.productInfo {
  padding: 10px;
}

.productInfo .title {
  font-size: 16px;
  border-left: 4px solid #1890FE;
  padding-left: 10px;
  margin: 0 10px;
}
</style>